import { render, staticRenderFns } from "./CmgBag.vue?vue&type=template&id=1a92e066&scoped=true&lang=pug"
import script from "./cmg-bag.ts?vue&type=script&lang=ts&external"
export * from "./cmg-bag.ts?vue&type=script&lang=ts&external"
import style0 from "./CmgBag.vue?vue&type=style&index=0&id=1a92e066&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a92e066",
  null
  
)

export default component.exports